/**
 * 配置模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from './axios';
import qs from 'qs';
//获取策略参数设置
export const getConfigBasic = (params)=>{
  return axios.post(`${base.base}/config/get_config_basic`,
    qs.stringify(params)
  )
};
//修改策略参数设置
export const updateConfigBasic = (params)=>{
  return axios.post(`${base.base}/config/update_config_basic`,
    qs.stringify(params)
  )
};
//获取合约参数设置
export const getConfigNowOrIndex = (params)=>{
  return axios.post(`${base.base}/config/get_config_now_or_index`,
    qs.stringify(params)
  )
};
//修改合约参数设置
export const updateConfigNowOrIndex = (params)=>{
  return axios.post(`${base.base}/config/update_config_now_or_index`,
    qs.stringify(params)
  )
};
export default getConfigBasic;



// WEBPACK FOOTER //
// ./src/api/config.js